import React from 'react';
import { useNavigate } from 'react-router-dom';
import FeaturedSolutions, { AgilysysLogo } from '../components/FeaturedSolutions';

const A = '/assets/casino/solutions/';

const solutions = [
  { name: 'Guest App',            path: 'guest-app', screenshot: A + 'app-guest.png' },
  { name: 'Book',                 path: 'book',      screenshot: A + 'app-booking.png' },
  { name: 'Reserve',              path: 'reserve',   screenshot: A + 'app-reservations.png' },
  { name: 'Loyalty & Promotions', path: 'loyalty',   screenshot: A + 'app-membership.png' },
  { name: 'Digital Marketing',    path: 'marketing', screenshot: A + 'app-anniversary.png' },
];

function Connection() {
  const navigate = useNavigate();
  return (
    <div className="page splash connectionPage">
      <div className="background" />
      <div className="page-header">Continuous Connection</div>
      <div className="text-blocks">
        <div className="std-text">
          Continue the guest connection post-stay to transform service into hospitality, drive positive reviews and encourage repeat visits. Surveys enrich unified guest profiles and shape future offers. Drive higher return visit spend with personalized offers.
        </div>
      </div>
      <FeaturedSolutions>
        {solutions.map((sol) => (
          <div key={sol.path} className="featured-item" onClick={() => navigate(`/solutions/${sol.path}`)}>
            <div className="item-head"><AgilysysLogo />{sol.name}</div>
            <img src={sol.screenshot} alt={sol.name} />
          </div>
        ))}
      </FeaturedSolutions>
    </div>
  );
}

export default Connection;
